// Lifecycle of the two candles: out -> igniting -> lit -> extinguishing -> out.
// The router waits for `extinguish` before it continues a navigation.

export const IGNITE_MS = 850;
export const EXTINGUISH_MS = 900;

export function prefersReducedMotion() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

let igniteTimer = null;
let extinguishPromise = null;

export default {
  namespaced: true,
  state: {
    phase: 'out',
  },
  mutations: {
    SET_PHASE(state, phase) {
      state.phase = phase;
    },
  },
  actions: {
    ignite({ commit }) {
      clearTimeout(igniteTimer);
      extinguishPromise = null;

      if (prefersReducedMotion()) {
        commit('SET_PHASE', 'lit');
        return Promise.resolve();
      }

      commit('SET_PHASE', 'igniting');

      return new Promise((resolve) => {
        igniteTimer = setTimeout(() => {
          commit('SET_PHASE', 'lit');
          resolve();
        }, IGNITE_MS);
      });
    },

    // A second call while the candles are going out returns the same promise,
    // so a navigation started during the animation replaces the earlier one.
    extinguish({ commit, state }) {
      if (prefersReducedMotion() || state.phase === 'out') {
        return Promise.resolve();
      }

      if (extinguishPromise) {
        return extinguishPromise;
      }

      clearTimeout(igniteTimer);
      commit('SET_PHASE', 'extinguishing');

      extinguishPromise = new Promise((resolve) => {
        setTimeout(() => {
          commit('SET_PHASE', 'out');
          extinguishPromise = null;
          resolve();
        }, EXTINGUISH_MS);
      });

      return extinguishPromise;
    },
  },
};
